module.exports = __webpack_public_path__ + "static/media/team6.72842d39.jpg";